import { GEO_COUNTRY_HEADER } from '~/shared/constants/geo'

// Resolved once on the server from the header the edge middleware forwards, then
// transferred to the client with the payload.
export function useGeoCountry() {
  return useState<string>('geo-country', () => {
    return useRequestHeaders([GEO_COUNTRY_HEADER])[GEO_COUNTRY_HEADER] || ''
  })
}
